import styled from "styled-components";

export const ShortCutContainerStyled = styled.div``;
